import { Inject, Injectable } from '@angular/core';
import { Event } from '@shared/models';
import { GenericCrudService, getCrudName } from '@shared/modules/crud';
import { DefaultRessourceStore } from '@shared/services/stores/default-ressource-store.service';

@Injectable()
export class EventStore extends DefaultRessourceStore<Event> {
    constructor(@Inject(getCrudName(Event)) protected crudService: GenericCrudService<Event>) {
        super(crudService, {
            customOptions: { projectionReservation: 'user' },
        });
    }

    protected getProjection(): string {
        return 'forEventDetailForApplication';
    }
}